import { render, staticRenderFns } from "./RejectionReasonDialog.vue?vue&type=template&id=c04d651e&scoped=true"
import script from "./RejectionReasonDialog.vue?vue&type=script&lang=js"
export * from "./RejectionReasonDialog.vue?vue&type=script&lang=js"
import style0 from "./RejectionReasonDialog.vue?vue&type=style&index=0&id=c04d651e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04d651e",
  null
  
)

export default component.exports